import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { trackClickMessage, trackClickRecommendation, trackShowRecommendations } from './tracking';
import { retrySendMessageById } from '../../actions/sendMessage/retrySendMessageById';
import { OfferMessage } from '../../components/OfferMessage';
import { CHATBOT_ID } from '../../constants/chatbotId';
import { currentOpenChatIDSelector } from '../../selectors';
import { TMessage, TOutcomingStatus } from '../../types/messages';

type TOfferMessageContainerProps = {
  isOutcoming: boolean;
  isMessageFailed: boolean;
  messageId: string;
  message: TMessage & { status: TOutcomingStatus };
};

export const OfferMessageContainer: React.FC<TOfferMessageContainerProps> = ({
  isMessageFailed,
  isOutcoming,
  message,
  messageId,
}) => {
  const dispatch = useDispatch();
  const chatId = useSelector(currentOpenChatIDSelector);
  const offer = message?.offers && message?.offers[0];

  const handleReload = React.useCallback(() => {
    dispatch(retrySendMessageById(chatId as string, messageId));
  }, [chatId, dispatch, messageId]);

  const onShow = React.useCallback(() => {
    if (chatId === CHATBOT_ID && offer) {
      trackShowRecommendations(offer.realtyOfferId);
    }
  }, [chatId, offer]);

  const onClick = React.useCallback(() => {
    if (chatId === CHATBOT_ID && offer) {
      trackClickRecommendation(offer.realtyOfferId);
    } else if (offer && chatId) {
      trackClickMessage(offer.realtyOfferId, chatId, messageId, message.communicationId);
    }
  }, [chatId, offer]);

  if (!offer) {
    return null;
  }

  const { formattedAddress, formattedInfo, formattedPrice, formattedOldPrice, url, photoUrls } = offer;

  return (
    <OfferMessage
      isOutcoming={isOutcoming}
      formattedAddress={formattedAddress}
      formattedInfo={formattedInfo}
      formattedPrice={formattedPrice}
      formattedOldPrice={formattedOldPrice}
      shareUrl={url}
      photoUrl={photoUrls[0]}
      withReload={isMessageFailed}
      onReload={handleReload}
      onShow={onShow}
      onClick={onClick}
    />
  );
};
